import React from 'react';

const AboutSection2 = () => {
    return (
        <div className='flex flex-col gap-6 px-4 sm:px-8 md:px-16 lg:px-64 py-10'>
            <p className='text-center font-nunito text-[22px] sm:text-[26px] md:text-[30px] lg:text-[32px] font-semibold leading-tight'>
                Who We Are?
            </p>
            <p className='font-nunito text-[14px] sm:text-[15px] md:text-[17px] lg:text-[18px] font-medium leading-relaxed text-justify'>
                The company was established in the year 2019, with the goal to provide high-quality, cost-effective services to businesses. We desire to grow each day to become the most trusted partner for our clients, delivering top-notch software development services. Today, we have a team of experienced and skillful professionals — software engineers, technology enthusiasts, and creative designers. Within a short time span, we have successfully delivered over 50+ projects to clients worldwide.
            </p>
        </div>
    );
};

export default AboutSection2;
